export const conversationBaseFields = `
  id
  createdAt
  mentions {
    avatarUri
    email
    entityId
    entityType
    firstName
    jobTitle
    lastName
    mobilePhone
    phoneNumber
  }
  message
  ownerType
  parentId
  updatedAt
  attachments {
    id
    conversationThreadId
    createdAt
    filename
    mime
    uri
  }
  owner {
    id
    email
    firstName
    lastName
    mobilePhone
    photo
  }
`;
